function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "703B1BAE-F583-43E7-A552-F6ECFE5F2550");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "WishMaker-Sekundarny-trh-6_0_6",
  transform: "translate(-700.000000, -282.000000)",
  stroke: "#F71D1D",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(428.000000, 162.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Error_Icon",
  transform: "translate(272.000000, 120.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "x",
  transform: "translate(14.000000, 14.000000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("line", {
  x1: 12,
  y1: 0,
  x2: 0,
  y2: 12,
  id: "Path"
}), /*#__PURE__*/React.createElement("line", {
  x1: 0,
  y1: 0,
  x2: 12,
  y2: 12,
  id: "Path"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 20,
  cy: 20,
  r: 19
})))));

var SvgErrorIcon = function SvgErrorIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgErrorIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Error_Icon.2d05396a.svg";
export { ForwardRef as ReactComponent };